import { Badge, Button, Flex, Image, Input, InputGroup, InputLeftAddon, InputRightAddon, Text } from '@chakra-ui/react'
import { IoMdSearch } from 'react-icons/io'
import { useQuery } from 'react-query'
import { useSearchParams } from 'react-router-dom'
import Axios from 'axios'
import { serializeFormQuery } from '../../../../utils/serializeFormQuery'
import { PageTransition } from '../../../../components/PageTransition'

async function getProducts({ codProd }) {
  const response = await Axios.get(`${process.env.REACT_APP_BASE_URL}/arte-produto/produto/${codProd}`)

  return response.data
}

export function FotoGaleriaStep() {
  let [searchParams, setSearchParams] = useSearchParams()

  const { data: product, isLoading } = useQuery({
    queryKey: ['products', { codProd: searchParams.get('codProd') }],
    queryFn: () => getProducts({ codProd: searchParams.get('codProd') }),
    enabled: !!searchParams.get('codProd'),
  })

  function onSubmit(event) {
    event.preventDefault()

    let params = serializeFormQuery(event.target)

    console.log(params)

    setSearchParams(params)
  }

  return (
    <PageTransition>
      <Flex flexDir="column" bg="white" minH="100vh">
        <Text textAlign="center" fontSize="24px" color="#1C2126" my="27px" maxW="326px" mx="auto">
          Para qual produto você deseja enviar a foto?
        </Text>
        <Flex px={3} alignItems="center" justifyContent="center" py="27px" boxShadow="0px 2px 6px #00000029">
          <InputGroup as="form" onSubmit={onSubmit}>
            <InputLeftAddon children="Código" borderRadius={0} />
            <Input
              borderRadius={0}
              name="codProd"
              placeholder="Digite o código do produto"
              borderRight="0"
              borderColor="#CFCFCF"
              _focus={{ borderColor: '#80BC00' }}
            />
            <InputRightAddon
              p={0}
              children={
                <Button type="submit" borderRadius={0} borderLeft="0" bg="#80BC00" color="white">
                  <IoMdSearch size="25" />
                </Button>
              }
            />
          </InputGroup>
        </Flex>

        {!product ? (
          <Image src="https://via.placeholder.com/430x440" alt="Placeholder" w="100%" mt="54px" />
        ) : (
          <Flex
            alignItems="center"
            justifyContent="center"
            px={{
              base: '16px',
              md: '0px',
            }}
          >
            <Flex
              maxW={{
                sm: '100%',
                md: '354px',
              }}
              flexDir="column"
              w="full"
              mt="54px"
              border="1px solid #ccc"
            >
              <Badge maxW="50%" bg="#F5F5F5" color="#80BC00" borderRadius={0} textAlign="center">
                NOVIDADE
              </Badge>
              <Flex gap={2} m={2}>
                <Image src={product.imagem} alt="Placeholder" border="1px solid #ccc" w="50%" h="212px" objectFit="contain" />
                test
              </Flex>
            </Flex>
          </Flex>
        )}
      </Flex>
    </PageTransition>
  )
}
